import React from "react";
import { Helmet } from "react-helmet";

const Concerts = () => {
  return (
    <>
      <Helmet>
        <meta name="description" content="TribeIn" />
        <title>TribeIn</title>
      </Helmet>
      <div
        style={{
          // width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "20px",
          fontSize: "30px",
          color: "white",
        }}
      >
        Coming soon.
      </div>
    </>
  );
};

export default Concerts;
